'use client'

import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

import heroBackground from '../../../public/images/Header Graphics.svg'

export const HeroBackground = styled(Box)(({ theme }) => ({
  background: `url("${heroBackground.src}") no-repeat 50%`,
  backgroundSize: 'cover',
  padding: theme.spacing(5.5, 0),
}))

export default {}
